export enum NotiSayacTur {
 Havale = 'havale',
 Imza = 'imza',
 Tum = 'tum',
 BirimEvrak = 'birimevrak',
 BirimEvrakKabul = 'birimevrakkabul',
 Taslak = 'taslak',
 GelenBelge = 'kgelenevrak',
 BGidenEvrak = 'bgidenevrak',
 
}